import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import axios from 'axios'
import UUID from 'uuid-js'
import VueTvFocusable from 'vue-tv-focusable'



Vue.use(VueTvFocusable, {
    // 可选配置项（根据需求调整）
    focusClassName: 'tv-focus',    // 自定义焦点样式类名（默认 'focus'）
    initDisplacement: 1,          // 初始移动步长（默认 1）
    enterToClick: true,            // 回车键触发点击事件（默认 true）
    longPressTime: 500,            // 长按判定时间（毫秒，默认 500）
    // 其他配置...
})
Vue.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
        // 聚焦元素
        el.focus();
    }
})
// import Mock from './mock/mock'
// Mock.mockData()
import {BASE_URL} from "./urlConfig/index";
/*
    图片上传，获取验证码两个接口不使用根路径
*/
// axios.defaults.baseURL = 'https://api.huoxingy.com/v1/admin/';
// axios.defaults.baseURL = BASE_URL+'/v1/admin/';
// 
// 根据环境来选择api地址
let baseUrl = window.location.hostname;
console.log(baseUrl)
switch (baseUrl) {
    case "localhost":
        // axios.defaults.baseURL = 'https://prod-api.huoxingy.com/v1/admin/';
        axios.defaults.baseURL = 'https://staging-api.huoxingy.com/v1/admin/';
        // axios.defaults.baseURL = 'http://192.168.0.107:9090/v1/admin/';
        break;
    case "10.0.0.23":
        axios.defaults.baseURL = 'https://staging-api.huoxingy.com/v1/admin/';
        break;
    case "192.168.2.68":
        axios.defaults.baseURL = 'https://staging-api.huoxingy.com/v1/admin/';
        break;
    case "staging-admin.huoxingy.com":
        axios.defaults.baseURL = 'https://staging-api.huoxingy.com/v1/admin/';
        break;
    case "prod-test-admin.huoxingy.com":
        axios.defaults.baseURL = 'https://prod-test-api.huoxingy.com/v1/admin/';
        break;
    default:
        axios.defaults.baseURL = 'https://prod-api.huoxingy.com/v1/admin/';
        break;
}
//
// 
axios.defaults.headers.post['Content-Type'] = 'application/json';

/*
    设置请求拦截器
*/
axios.interceptors.request.use(function(config) {
    // console.log(config);

    // 获取验证码，注册不能带token验证
    /*if ( config.url.indexOf('v1/verify-code') >= 0 || config.url.indexOf('v1/admin/sign-up') >= 0 ) {
        return config;
    }*/
    let token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});

/*
    添加响应拦截器
*/
axios.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    if (error.response) {
        let tipText;
        error.response.data.message?tipText=error.response.data.message:tipText=error.response.data;
        if ( error.response.status == 401 ) {
            window.location.href = window.location.href.split('#')[0]+'#/login';
            tipText = '帐号失效，请重新登录';
        } else if ( error.response.status == 403 ) {
            // window.location.href = window.location.href.split('#')[0]+'#/login';
            tipText = '权限不足';
        }else if ( error.response.status == 404 ) {
            // window.location.href = window.location.href.split('#')[0]+'#/login';
            tipText = '请尽快上传资料';
        }else if ( error.response.status == 503 ) {
            // window.location.href = window.location.href.split('#')[0]+'#/login';
            tipText = '请尽22快上传资料';
        }

        ElementUI.Message.error({
            message: tipText,
            customClass: 'error'
        })
    }
    return Promise.reject(error);
});

Date.prototype.Format = function (fmt) { //author: meizz 
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/*
    添加自定义过滤器
*/

Vue.filter('toFixedNum', function (value) {
    // if (!value) return 0;
    value = Number(value);
    return value.toFixed(2);
})

Vue.filter('numberToDate', function ( val ) {
    if ( !val ) {
        return '';
    }
    let date = new Date(val);
    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
    return dateStr;
})
Vue.filter('numberToAllDate', function ( val ) {
    if ( !val ) {
        return '';
    }
    let date = new Date(val);
    let dateStr = date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate()+' '+ (date.getHours()<10?'0'+date.getHours():date.getHours()) + ':' + (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes());
    return dateStr;
})
Vue.filter('numberToMonthDate', function ( val ) {
    if ( !val ) {
        return '';
    }
    let date = new Date(val);
    let dateStr = ((date.getMonth()+1)<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'.'+(date.getDate()<10?'0'+date.getDate():date.getDate())+'-'+ (date.getHours()<10?'0'+date.getHours():date.getHours()) + ':' + (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes())+ ':' + (date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds());
    return dateStr;
})
Vue.filter('numberToTime', function ( val ) {
    if ( !val ) {
        return '';
    }
    let date = new Date(val);
    let dateStr = (date.getMonth()+1)+'.'+date.getDate()+'-'+ (date.getHours()<10?'0'+date.getHours():date.getHours()) + ':' + (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes());
    return dateStr;
})

Vue.filter('dateForGradePage', function (value) {
    if (!value) return ''
    let date = new Date(value);
    let year = date.getFullYear();
    let month = (date.getMonth() + 1)>9?(date.getMonth() + 1):"0"+(date.getMonth() + 1);
    let day = date.getDate()>9?date.getDate():"0"+date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes()>9?date.getMinutes():"0"+date.getMinutes();
    let seconds = date.getSeconds()>9?date.getSeconds():"0"+date.getSeconds();
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  })


  Vue.filter('numberToMuchDay', function ( val ) {
    if ( !val ) {
        return '';
    }
    let dateArr = val.split('.');
    let dateStr = dateArr[0];
    let date = new Date(dateStr.replace(/-/g,"/")).getTime();
    let nowDate = new Date().getTime();
    let timeStr = nowDate - date;
    let oneDay = 1000*60*60*24;
    let day = Math.floor(timeStr / oneDay);
    let hours=Math.floor((timeStr % oneDay)/(3600*1000))
    if(day > 0){
        return day + "天前";
    }else{
        return "今天";
    }
})

Vue.prototype.$uuid = UUID
/*
  生产UUID：this.$uuid.create(1)
*/


router.beforeEach((to, from, next) => {
    if(to.name == "rewardInfo" || 
        to.name == "ratingInfo"|| 
        to.name == "getWithdraw"|| 
        to.name == "putWithdraw"||
        to.name == "setWithdraw" || 
        to.name == "dlCall"){
        if(JSON.parse(sessionStorage.getItem("call"))){
            return next();
        }else{
            return next({path: "/"});
        }
    }
    next();
})
router.beforeEach((to, from, next) => {
    if(to.name == "bigScreenFrontEnd"){
        next();
        return;
    }
    next();
})
router.beforeEach((to, from, next) => {
    if(to.name == "market" || 
        to.name == "address"||
        to.name == "orderInfo"){
        if(JSON.parse(sessionStorage.getItem("purchase"))){
            return next();
        }else{
            return next({path: "/"});
        }
    }
    next();
})





Vue.prototype.$http = axios
Vue.prototype.$message = ElementUI.Message;

Vue.prototype.$canClickSelect = (sessionStorageName,timeStr,nowTime)=>{
    let sessionStorageData = sessionStorage.getItem(sessionStorageName);
    let defaultTimeRange = 5*1000;//默认30秒
    if(sessionStorageData){
        let localData = JSON.parse(sessionStorageData);
        let timeRange = nowTime - localData.localTime;
        console.log(localData.localTime)
        if(localData.timeStr==timeStr && timeRange < defaultTimeRange){
            return false;
        }
        let data = {
            sessionStorageName,
            timeStr,
            localTime:nowTime
        }
        sessionStorage.setItem(sessionStorageName,JSON.stringify(data));
        return true;
    }else{
        // 首次点击的时间
        let localTime = new Date().getTime();
        // 
        let data = {
            sessionStorageName,
            timeStr,
            localTime
        }
        sessionStorage.setItem(sessionStorageName,JSON.stringify(data));
        return true;
    }
};
Vue.use(ElementUI)

Vue.config.productionTip = false

let dateRange = {
   currentDate: new Date(),
   millisecond: 1000 * 60 * 60 * 24,//一天的毫秒数
   getThisWeek: function() {
       //起止日期数组
       var startStop = new Array();
       //返回date是一周中的某一天
       var week = dateRange.currentDate.getDay();
       //减去的天数
       var minusDay = week != 0 ? week - 1 : 6;
       //本周 周一
       var monday = new Date(dateRange.currentDate.getTime() - (minusDay * dateRange.millisecond));
       //本周 周日
       var sunday = new Date(monday.getTime() + (6 * dateRange.millisecond));
       //添加本周时间
       startStop.push(dateRange.formatterDate(monday)); //本周起始时间
       //添加本周最后一天时间
       startStop.push(dateRange.formatterDate(sunday)); //本周终止时间
       //返回
       return startStop;
   },
   /**
    * 获得上一周的起止日期
    */
   getLastWeek: function() {
       //起止日期数组
       var startStop = new Array();
       //返回date是一周中的某一天
       var week = dateRange.currentDate.getDay();
       //减去的天数
       var minusDay = week != 0 ? week - 1 : 6;
       //获得当前周的第一天
       var currentWeekDayOne = new Date(dateRange.currentDate.getTime() - (dateRange.millisecond * minusDay));
       //上周最后一天即本周开始的前一天
       var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - dateRange.millisecond);
       //上周的第一天
       var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - (dateRange.millisecond * 6));

       startStop.push(dateRange.formatterDate(priorWeekFirstDay));
       startStop.push(dateRange.formatterDate(priorWeekLastDay));
       //返回
       return startStop;
   },
   /**
    * 获得这个月的起止日期
    */
   getThisMonth: function() {
       var startStop = new Array();
       //获得当前月份0-11
       var currentMonth = dateRange.currentDate.getMonth();
       //获得当前年份4位年
       var currentYear = dateRange.currentDate.getFullYear();
       //求出本月第一天
       var firstDay = new Date(currentYear, currentMonth, 1);
       //当为12月的时候年份需要加1
       //月份需要更新为0 也就是下一年的第一个月
       //否则只是月份增加,以便求的下一月的第一天
       if (currentMonth == 11) {
           currentYear++;
           currentMonth = 0;
       } else {
           currentMonth++;
       }
       //下月的第一天
       var nextMonthDayOne = new Date(currentYear, currentMonth, 1);
       //求出上月的最后一天
       var lastDay = new Date(nextMonthDayOne.getTime() - dateRange.millisecond);

       startStop.push(dateRange.formatterDate(firstDay));
       startStop.push(dateRange.formatterDate(lastDay));
       //返回
       return startStop;
   },
   /**
    * 获得上个月的起止日期
    */
   getLastMonth: function() {
       var startStop = new Array();
       //获得当前月份0-11
       var currentMonth = dateRange.currentDate.getMonth();
       //获得当前年份4位年
       var currentYear = dateRange.currentDate.getFullYear();
       var currentDay = new Date(currentYear, currentMonth, 1);
       //上个月的第一天
       //年份为0代表,是本年的第一月,所以不能减
       if (currentMonth == 0) {
           currentMonth = 11; //月份为上年的最后月份
           currentYear--; //年份减1
       }
       else {
           currentMonth--;
       }
       var firstDay =  new Date(currentYear, currentMonth, 1);
       //求出上月的最后一天
       var lastDay = new Date(currentDay.getTime() - dateRange.millisecond);

       startStop.push(dateRange.formatterDate(firstDay));
       startStop.push(dateRange.formatterDate(lastDay));
       //返回
       return startStop;
   },
   /**
    * 格式化日期（不含时间）
    */
   formatterDate : function(date) {
       var datetime = date.getFullYear()
           + "/"// "年"
           + ((date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : "0"
           + (date.getMonth() + 1))
           + "/"// "月"
           + (date.getDate() < 10 ? "0" + date.getDate() : date
               .getDate());
       return datetime;
   }
}

Vue.prototype.$dateRange = dateRange

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js